import { normalizeSubscriptionPaymentMethod } from './index';

export const mapJussubSubscription = (data) => {
  const { subscription } = data;
  const planAmount = subscription.plan?.amount ?? null;
  const chargedAmount = subscription.amount ?? planAmount;

  const addons = (subscription.addons ?? []).map((addon) => ({
    id: addon.id,
    name: addon.name,
    amount: addon.amount,
    unitPrice: addon.unitPrice,
    itemCount: addon.itemCount,
  }));

  const coupons = (subscription.coupons ?? []).map((coupon) => ({
      id: coupon.id,
      name: coupon.name ?? coupon.code,
      expiresAt: coupon.expiresAt,
  }));

  return {
    client_id: data.client_id,
    external_id: data.external_id,
    plan_details: {
      name: subscription.plan?.name ?? null,
      amount: planAmount ?? chargedAmount,
      periodicity: subscription.plan?.cycleDays ?? null,
    },
    info: {
      status: subscription.status?.toLowerCase?.() ?? subscription.status,
      provider: 'jussub',
      subscription_provider: 'jussub',
      plan: subscription.plan?.name ?? null,
      charged_amount: chargedAmount,
      plan_amount: planAmount ?? chargedAmount,
      payment_method: normalizeSubscriptionPaymentMethod(
        subscription.paymentMethod,
      ),
      current_period_start: subscription.cycleStartDate,
      current_period_end: subscription.cycleEndDate,
      latest_update: subscription.updatedAt,
      subscription_id: subscription.id,
      addons,
      coupons,
    },
  };
};
